<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container grid-list-xl pt-0>
        <page-tool-bar
            show_search
            show_date_start
            show_date_end
            :loading="loader"
            :search.sync="search"
            :date_start.sync="date_start"
            :date_end.sync="date_end"
        >
            <v-flex xs12 md2>
                <v-select
                    label="Người nhận"
                    :disabled="loader"
                    v-model="chosen_receiver"
                    :items="[...bvs, { name: 'Tất cả'}]"
                    item-text="name"
                    item-value="name"
                    prepend-icon="person_pin"
                    hide-details
                ></v-select>
            </v-flex>
            <v-flex shrink>
                <div class="text-right">
                    <dialog-tao-phieu-chi @reloadTable="reload_table++"></dialog-tao-phieu-chi>
                </div>
            </v-flex>
        </page-tool-bar>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <v-card>
                    <table-phieu-chi
                        :date_start="date_start"
                        :date_end="date_end"
                        :search="search"
                        :chosen_receiver="chosen_receiver"
                        :reload_table="reload_table"
                        :loader.sync="loader"
                    ></table-phieu-chi>
                </v-card>
            </v-flex>
        </v-layout>
        
    </v-container>
</div>
</template>

<script>

import DialogTaoPhieuChi from "./DialogTaoPhieuChi"
import TablePhieuChi from "./TablePhieuChi"
import moment from 'moment'

export default {
    name: "phieu-chi-layout",
    components: {
        DialogTaoPhieuChi,
        TablePhieuChi
    },
    data(){
        return {
            reload_table: 0,
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substr(0, 10),
            loader: false,
            search: "",
            chosen_receiver: 'Tất cả'
        }
    },
    computed: {
        bvs(){
            return this.$store.state.app.bvs
        },
    },
    mounted(){
        this.reload_table++
    },
    watch: {
        date_start(){
            this.reload_table++
        },
        date_end(){
            this.reload_table++
        }
    }
}
</script>

<style>

</style>